import { render, staticRenderFns } from "./EntgeltGruppenDescription.vue?vue&type=template&id=4ac1a6fe&"
import script from "./EntgeltGruppenDescription.vue?vue&type=script&lang=js&"
export * from "./EntgeltGruppenDescription.vue?vue&type=script&lang=js&"
import style0 from "./EntgeltGruppenDescription.vue?vue&type=style&index=0&id=4ac1a6fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports